var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"sub-column tab-wrap"},_vm._l((_vm.menu),function(item,key){return _c('li',{key:key,class:[
      {'current': _vm.current===item.name},
      item.name
    ]},[_c('router-link',{attrs:{"to":item.to}},[_vm._v(_vm._s(item.text))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }